import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../EvBookingEditor/EvBookingEditorTypes";
import _EntityViewMixin from '../../../moreCore/UI/EntityBased/EntityView/EntityView';
import PepEmploymentEditor from './PepEmploymentEditor';
import { PEP, PepClassnames } from "../PepTypes";
import _WidgetBase from 'dijit/_WidgetBase';

class PepEmploymentView extends compose(_EntityViewMixin<PEP.EmploymentData>) {
    //templateString = template;



   ///**
   // *
   // * @param entityId
   // * @param label
   // * @param additionalParams
   // * @param tabContainerName Name des Tabcontainers, in die die Ansicht ggf. maximiert werden kann
   // * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
   // * @param disableDefaultButtons Entfernt die Standardbuttons für Reports, Löschen und sonstige Entity-Interaktionen. Neue Buttons können mit addButton eingefügt werden.
   // */
   // setup(entityId: string,
   //     label: string,
   //     additionalParams?: Object,
   //     contextName?: string,
   //     tabContainerName?: string) {

   //     if (additionalParams) {
   //         this.config.additionalRequestParams = lang.clone(additionalParams);
   //     }

   //     if (contextName) this.setContextName(contextName);

   //     this.showAsDlg(entityId, label, tabContainerName);

    // }




    onShow() {
        if (this.useDefaultButtons !== false) {
            this.handleAdditionalButtons();
        }

        
    }

    private handleAdditionalButtons() {

    }


    protected onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {

        let editor = new PepEmploymentEditor();

        //editor.startup();
        if (!this.isEmbeddedInTab) this.tryMoveToTab(false);

        if (this.isEmbeddedInTab) {
            this.createNewTabbedContent({
                widget: editor,
                enableClosing: true,
                label: this.title,
                name: this.internalName,
                coloration: null,
                groupLabel: this.groupLabel,
                iconclass: "fas fa-edit",
                sidebarEntryName: this.internalName,
                targetContainerName: this.getTabContainerName()
            }, true, true);
        }

        editor.setData(this.entity);
        editor.on("submit", lang.hitch(this, this._onEditorSaved));

        return editor;
    }



    private _onEditorSaved(response: PEP.ResultData) {
        // TODO
    }


    postCreate(): void {

        this.config = {
            entityClassname: PepClassnames.vt_empl_A,
            labelProperty: "gDisp_1",
            entityClassPrintname: "PEP_Label_VtEmplA",
            //userroleClone: null,
            //featurePathClone: null,
            //userroleEdit: "PEP",
            //featurePathEdit: null,//"EvBooking/EvBookingEditor",
            //userroleDelete: null,
            //featurePathDelete: null
        }
        super.postCreate.apply(this, arguments as any);


    //    this.checkPrivileges();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PepEmploymentView);
